export const FasMap = {
    "loading": {name: "fa-spinner wa-animation-spin"},
    "darr": {name: "fa-sort-down"},
    "uarr": {name: "fa-sort-up"},
    "rarr": {name: "fa-caret-right"},
    "add": {name: "fa-plus-circle"},
    "sort": {name: "fa-bars"},
    "edit": {name: "fa-pencil-alt"},
    "marker": {name: "fa-map-marker-alt"},
    "settings": {name: "fa-cog"},
    "design": {name: "fa-palette"},
    "script": {name: "fa-file-code"},
    "script-css": {name: "fab fa-css3-alt"},
    "delete": {name: "fa-minus-circle"},
    "update": {name: "fa-redo-alt"},
    "map": {name: "fa-map"},
    "map-edit": {name: "fa-vector-square"},
    "rotate-left": {name: "fa-undo"},
    "ss excel": {name: "fa-file-excel"},
    "ss refunded": {name: "fa-times"},
    "color": {name: "fa-circle"},
    "yes": {name: "fa-regular fa-check"},
    "no": {name: "fa-times"},
    "palette": {name: "fa-palette"},
    "status-green": {name: "fa-circle"},
    "status-red": {name: "fa-circle"},
    "script-lock": {name: "fa-lock"},
    "exclamation": {name: "fa-exclamation"},
    "download": {name: "fa-file-download"},
    "box": {name: "fa-box"},
    "sync": {name: "fa-sync"},
    "no-bw": {name: "fa-times"},
    "folder": {name: "fa-folder"},
    "funnel": {name: "fa-filter"},
    "comments": {name: "fa-comments"},
    "move": {name: "fa-long-arrow-alt-right"},
    "star": {name: "fa-star"},
    "status-yellow-tiny": {name: "fa-circle", color: "yellow"},
}